export var CollaboratorAccessLevel;
(function (CollaboratorAccessLevel) {
    CollaboratorAccessLevel[CollaboratorAccessLevel["All"] = 0] = "All";
    CollaboratorAccessLevel[CollaboratorAccessLevel["External"] = 1] = "External";
})(CollaboratorAccessLevel || (CollaboratorAccessLevel = {}));
